jQuery(document).ready(function($) {
  setTimeout(function() {
    $('.jdgm-carousel__item-wrapper').slick('slickSetOption', {
      arrows: false,  
      dots: true     
    }, true);
  }, 2000);
});
jQuery(document).ready(function($) {

  setTimeout(function() {
    $('.jdgm-carousel-item').each(function() {
      var $item = $(this);
      var $reviewer = $item.find('.jdgm-carousel-item__reviewer-name-wrapper');
      var $product = $item.find('.jdgm-carousel-item__product');
      if ($reviewer.length && $product.length && !$item.find('.jdgm-custom-wrapper').length) {
        var $wrapper = $('<div class="jdgm-custom-wrapper"></div>');
        $reviewer.add($product).wrapAll($wrapper);
      }
    });
  }, 2000);
});



const utilityBar = document.querySelector('.utility-bar');
const utilityBarHeight = utilityBar.offsetHeight; // height in pixels
document.documentElement.style.setProperty('--utility-bar-height', `${utilityBarHeight}px`);

const headerbar = document.querySelector('.header');
const headerheight = headerbar.offsetHeight; // height in pixels
document.documentElement.style.setProperty('--header-bar-height', `${headerheight}px`);

